import React from 'react'
import Main from '../../Layout/Main'
import Tittle from '../../Components/contact/Tittle'
import ContactSection from '../../Components/contact/ContactSection'
import Map from '../../Components/contact/Map'
import Subscribe from '../../Components/contact/Subscribe'

const Contact = () => {
  return (
    <Main>
        <Tittle/>
        <ContactSection/>
        <Map/>
        <Subscribe/>
    </Main>
  )
}

export default Contact